import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { AlertTriangle, RefreshCw, Mail, Phone } from 'lucide-react';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg overflow-hidden border border-red-100">
        <div className="bg-red-50 p-4 flex items-center">
          <AlertTriangle className="text-red-500 mr-3" size={24} />
          <h2 className="text-xl font-semibold text-red-600">Something went wrong</h2>
        </div>
        
        <div className="p-6">
          <div className="mb-4 p-3 bg-red-50 rounded-md">
            <p className="text-sm font-medium text-red-700">Error details:</p>
            <pre className="mt-2 text-xs text-red-600 overflow-x-auto p-2 bg-red-100 rounded">
              {error.message}
            </pre>
          </div>

          <div className="mb-6 p-3 bg-blue-50 rounded-md border border-blue-100">
            <p className="text-sm font-medium text-blue-700 mb-2">Technical Support</p>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex items-center">
                <Mail className="mr-2 text-blue-500" size={16} />
                <a href="mailto:faizanvart73@gmail.com" className="hover:underline">
                  faizanvart73@gmail.com
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="mr-2 text-blue-500" size={16} />
                <a href="tel:+919847864914" className="hover:underline">
                  +91 98478 64914
                </a>
              </div>
              <p className="text-xs mt-2">Contact Faiz Anvar T for immediate assistance</p>
            </div>
          </div>

          <button
            onClick={resetErrorBoundary}
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-base hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-base"
          >
            <RefreshCw className="mr-2" size={16} />
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

const ErrorBoundary = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload();
      }}
      onError={(error, info) => {
        // You could log errors to an error reporting service here
        console.error('ErrorBoundary caught an error:', error, info);
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;